export enum languages {
  EN = 'en',
  FR = 'fr',
  NL = 'nl',
}

export const supportedLanguages = Object.values(languages);

export const dataGridLangMap = {
  [languages.EN]: 'enUS',
  [languages.FR]: 'frFR',
  [languages.NL]: 'nlNL',
};
